export const enum AttachmentModes {
  Clients = 'clients',
  Sendouts = 'sendouts',
}
